import React from "react";

//styles
import withStyles from "@material-ui/core/styles/withStyles";
import featuresStyle from "assets/jss/material-kit-pro-react/views/sectionsSections/featuresStyle.jsx";

import ChartistGraph from "react-chartist";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import InfoArea from "components/InfoArea/InfoArea.jsx";

import School from "@material-ui/icons/School";

import { //satisfactionRatingsChart
    emailsSubscriptionChart
  } from "variables/charts";

import dashboardStyle from "assets/jss/material-dashboard-react/views/dashboardStyle.jsx";


class SectionPrincipals extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.section} style={{backgroundColor:"#efefef"}}>
      {/*}
        <GridContainer>
            <GridItem xs={false} sm={false} md={2}>&nbsp;</GridItem>
            <GridItem xs={12} sm={8} md={8} style={{textAlign:"center", paddingTop:"30px"}}>
              <h2 className={classes.title}>WHAT IS ALL THINGS E.Q.?</h2>
              <h5 className={classes.description}>
                All Things E.Q. is an easy to implement, Social Emotional Program that does NOT give your staff more to do but does create a positive school-wide culture that can be seen, felt and heard on campus.
              </h5>
            </GridItem>
    </GridContainer>*/}
    <br /><br />
    <div className={classes.container} >
        <div className={classes.features2} style={{marginTop:"0px", paddingTop:"0px"}}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={6}>
            <Card style={{marginTop:"120px"}}>
              <CardHeader color="warning">
                <ChartistGraph
                  className="ct-chart"
                  data={emailsSubscriptionChart.data}
                  type="Bar"
                  options={emailsSubscriptionChart.options}
                  responsiveOptions={emailsSubscriptionChart.responsiveOptions}
                  listener={emailsSubscriptionChart.animation}
                />
              </CardHeader>
              <CardBody>
                <h4 className={classes.cardTitle}>First Year Results</h4>
                <p className={classes.cardCategory}>
                  An average score of 4.1 out of 5.0 measuring impact, ease
                  of use and overall satisfaction in the very first year.
                </p>
              </CardBody>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={6} md={6}>
            <InfoArea
              icon={School}
              title="Principals"
              description={
                <span>
                  <p style={{color:'#232323', fontSize:"15px"}}>
                  Principals welcome the continued support All Things E.Q. provides and are pleased with the ongoing scaffolding and ease of implementation.  This is not another train your teachers, drain your resources and then ditch your school program, which is why we have 100% retention with our schools.  All Things E.Q. has spread by word of mouth alone to 20 different schools.  Our reputation speaks for itself and continues to spread quickly by word of mouth. Our material works and the differences we create can be felt on campus!
                  </p>
                </span>
              }
              iconColor="warning"
            />
          </GridItem>
        </GridContainer>
        </div></div>
      </div>
    );
  }
}

export default withStyles(featuresStyle, dashboardStyle)(SectionPrincipals);










// WEBPACK FOOTER //
// ./src/views/LandingPage/Sections/SectionPrincipals.jsx